import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { initFxRate } from "@/lib/api";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import VendorStore from "@/pages/VendorStore";
import Vendors from "@/pages/Vendors";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import BecomeVendor from "@/pages/BecomeVendor";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminPanel from "@/pages/AdminPanel";
import Subscriptions from "@/pages/Subscriptions";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import OrderTracking from "@/pages/OrderTracking";

function AppShell() {
  const location = useLocation();
  // Detect Emergent Google OAuth callback (session_id in URL hash) synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideChrome = ["/login", "/register"].includes(location.pathname);
  return (
    <>
      {!hideChrome && <Navbar />}
      <main className={hideChrome ? "" : "min-h-screen"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/p/:slug" element={<ProductDetail />} />
          <Route path="/proizvod/:slug" element={<ProductDetail />} />
          <Route path="/vendor/:id" element={<VendorStore />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/subscription-success" element={<SubscriptionSuccess />} />
          <Route path="/become-vendor" element={<BecomeVendor />} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/order/:order_id" element={<ProtectedRoute><OrderTracking /></ProtectedRoute>} />
          <Route path="/wishlist" element={<ProtectedRoute><Wishlist /></ProtectedRoute>} />
          <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
          <Route path="/vendor" element={<ProtectedRoute roles={["vendor", "admin"]}><VendorDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </>
  );
}

export default function App() {
  useEffect(() => { initFxRate(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppShell />
            <Toaster richColors position="top-center" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
